import Layout from "../components/layout";
import { BreadcrumbArrow } from "../components/breadcrumb-arrow";
import Link from "next/link";
import { page_getStaticProps } from "../lib/statics";
import Seo from "../components/seo";
import React from "react";
import Image from "next/image";

const createMarkup = (block) => {
  return { __html: block };
};

const About = ({ categories, page }) => {
  const seo = {
    metaTitle: `About Us`,
    metaDescription: `The largest manufacturer of custom tie-down straps in the United States.`,
  };

  return (
    <Layout categories={categories}>
      <Seo seo={seo} />
      <div className={`hidden lg:block border-t border-b pt-2 pb-2 bg-white`}>
        <div className="container mx-auto pl-1 pr-1">
          <ul className={`flex flex-row items-center space-x-4`}>
            <li>
              <Link href={`/`}>
                <a className={`hover:underline`}>Home</a>
              </Link>
            </li>
            <li>
              <span className={`flex flex-row items-center space-x-4`}>
                <BreadcrumbArrow />
                <span className={``}>About</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className={`lg:py-32 lg:px-32 bg-white`}>
        <div className="container mx-auto pl-1 pr-1">
          <h1 className={`font-display font-bold text-[64px] leading-none`}>
            {page.attributes.hero}
          </h1>
        </div>
      </div>

      {page.attributes.content.map((section, index) => {
        return (
          <div
            key={index}
            className={`wysiwyg p-8 lg:py-32 lg:px-32 bg-${
              index % 2 === 0 ? "[#F5F5F5]" : "white"
            }`}
          >
            <div className="container mx-auto lg:px-48">
              <div dangerouslySetInnerHTML={createMarkup(section.block)} />
            </div>
          </div>
        );
      })}
    </Layout>
  );
};

export async function getStaticProps() {
  return page_getStaticProps("about");
}

export default About;
